let html = `<div class="modal-pending">
    <div class="modal-pending__loading"></div>
    <div class="modal-pending__text">{text}</div>
</div>`

export default html